<template>
    <aside id="sidebar" class="sidebar">
        <ul class="sidebar-nav" id="sidebar-nav">
            <li class="nav-item">
                <router-link class="nav-link" :to="{name:'ConservationIndex'}" inactive-class="collapsed">
                    <img src="../assets/icon/sarpras-dashboard.png" alt="" style="width: 30px; padding-right: 5px;">
                    <span>Peta</span>
                </router-link>
            </li>
            <li class="nav-item">
                <router-link class="nav-link" :to="{name:'RegistrationIndex'}" inactive-class="collapsed">
                    <img src="../assets/icon/sarpras-drawer.png" alt="" style="width: 30px; padding-right: 5px;">
                    <span>Registrasi</span>
                </router-link>
            </li>
        </ul>
    </aside>
</template>

<script>
    export default {
        name: 'SidebarBendungan',
        data(){
            return{
                route: ''
            }
        },
    }
</script>